'use client';

import React, { useEffect } from 'react';
import { Box, Container, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import Accordion from './Accordion';
import { FAQContent, FAQItem } from '@/utils/types/faq';
import Button from './Button';
import { useResponsive } from '@/hooks/use-responsive';
import { MarkdownContent } from '@/app/page';

interface FAQSectionProps {
  markdownContent?: MarkdownContent;
}

const FAQSection = ({ markdownContent }: FAQSectionProps) => {
  // const { content } = useSectionContent('faq') as unknown as { content: FAQContent };
  const content = markdownContent?.frontmatter;

  const allQuestions = React.useMemo(() => {
    if (!content?.users?.length) return [];

    return content.users.reduce((acc: FAQItem[], user: { categories: { questions: never[]; }[]; }) => {
      const questions = user.categories?.[0]?.questions || [];
      return [...acc, ...questions];
    }, []).slice(0, 5);
  }, [content?.users]);

  useEffect(() => {
    console.log('FAQ Section Markdown Content:', markdownContent);
  }, [markdownContent]);

  if (!content || !allQuestions.length) return null;

  const gridSpacing = content.style?.grid?.spacing?.xs || 40;
  const paddingXs = content.layout?.padding?.xs || 40;
  const paddingLg = content.layout?.padding?.lg || 64;

  return (
    <Box
      py={{
        xs: paddingXs,
        lg: paddingLg
      }}
      bg={content.style?.background || ""}
    >
      <Container size="xl">
        <SimpleGrid
          spacing={{
            xs: gridSpacing,
            md: gridSpacing * 2
          }}
          cols={{
            xs: 1,
            md: 2
          }}
        >
          <Stack
            gap={content.style?.stack?.gap || 20}
            pos="sticky"
            top={content.style?.stack?.top || 120}
          >
            <Title
              order={2}
              size={content.style?.title?.fontSize || 48}
              fw={content.style?.title?.fontWeight || 700}
            >
              {content.title || "Have Questions?"}
            </Title>
            <Text
              size="xl"
              c={content.style?.textColor || "dimmed"}
            >
              {content.description || "Find answers to common questions."}
              {' '}

            </Text>
          </Stack>

          <Stack 
           gap={content.style?.stack?.gap || 20}
          >
            <Accordion data={allQuestions} />
            <Button
              component='a'
              href='/faq' aria-label='FAQ'
              hasArrow
              expandOnHover={false}
              variant='outline'
              
            >
              View all FAQs
            </Button>
          </Stack>
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default FAQSection;